export const FEATURE_FLAGS = {
  PRODUCT_PERFORMANCE: 'prod_perf',
  GRAFANA_REPORT: 'grafana',
  AI_VM: 'ai_vm',
} as const

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS]

export interface IGrafanaFlagValue {
  perm: 0 | 1
  title: string
}
